import likertSlider from "surveylabJsAssets/page/_likert-slider";

export default function () {
    likertSlider.initOnce();
}